<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">基础设置</el-breadcrumb-item>
                    <el-breadcrumb-item>系统设置</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form :model="orderTip" :rules="rules" ref="orderTip" label-width="150px"  size="mini" :height="tableHeight">
                    <el-form-item label="登录页背景图片">
                        <el-upload
                        class="upload-demo"
                        drag
                        action="/api/systemSet/uploadLoginImage"
                        multiple
                        :limit="1"
                        :show-file-list="true"
                        :on-exceed="handleExceed"
                        :file-list="fileList"
                        :before-upload="beforeAvatarUpload"
                        :on-success="uploadSuccess">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传jpg文件</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="登录框离上边距离" prop="carrierName" >
                        <el-input-number v-model="systemSet.loginMarginTop" controls-position="right" :min="0" :max="100" :precision="0"></el-input-number>
                    </el-form-item>
                    <el-form-item label="登录框离左边距离" prop="carrierName" >
                        <el-input-number v-model="systemSet.loginMarginLeft" controls-position="right" :min="0" :max="100" :precision="0"></el-input-number>
                    </el-form-item>
                    <div class="xin-footer" style="position: fixed;bottom: 20px;right: 50px;">
                        <el-row type="flex" style="justify-content: right;">
                            <el-button size="mini" type="primary" @click="submitForm()" :loading="loading">保存</el-button>
                        </el-row>
                    </div>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>

    export default {
        name:'SystemSet',
        components: {
        },
        data() {
            return {
                systemSet: {},
                direction: 'rtl',
                currentPage: 1,
                pageSize:10,
                total:10,
                timer:'',
                currentUserId: "",
                rules: {
                },
                loading: false,
                tableHeight: "",//表格高度
                fileList: [],
            }
        },
        methods: {
            submitForm() {
                this.loading = true;
                this.$axios.post("/systemSet/save", this.systemSet).then(res => {
                    if (res.data.status === "success") {
                        this.$message({
                            message: "保存成功！",
                            type: "success"
                        });
                    } else {
                        this.$message.error(res.data.message);
                    }
                    this.loading = false;
                }, error => {
                    this.$message.error(error.message);
                    this.loading = false;
                });
            },
            handleExceed() {
                this.$message.warning(`当前限制选择 1 个文件`);
            },
            beforeAvatarUpload(file) {
                let fileName = file.name;
                let pos = fileName.lastIndexOf(".");
                let lastName = fileName.substring(pos, fileName.length);
                if (lastName.toLowerCase() !== ".jpg") {
                    this.$message.error("文件必须为jpg类型");
                    return false;
                    
                }
                return true;
            },
            uploadSuccess(res) {
                if (res.status === "success") {
                    this.$message({
                        message: '登录页背景图片替换成功，请强制刷新查看效果！',
                        type: 'success'
                    });
                } else {
                    this.$message.error(res.message);
                }
            },
            getTableHeight() {
                let tableH = 160; //距离页面下方的高度
                this.tableHeight = window.innerHeight - tableH;
            },
            querySystemSet() {
                this.$axios.post("/systemSet/find").then(res => {
                    if (res.data.status === "success") {
                        this.systemSet = res.data.result;
                    } else {
                        this.$message.error(res.data.message);
                    }
                }, error => {
                    this.$message.error(error.message);
                });
            }
        },
        created() {
            this.getTableHeight();
            this.querySystemSet();
        }
        
    }


</script>

<style scoped>

   .el-form {
       margin-top: 30px;
   }
   /* .el-select {
        width: 360px;
    }

    .el-input {
        width: 360px;
    }
    .el-date-picker {
        width: 360px;
        background-color: green;
    }
    .el-cascader {
        width: 360px;
    }
    .el-input-number {
        width: 360px;
    } */
   .block {
       text-align: right;
       margin-top: 10px;
   }

    .box-card {
        width: 800px;
        position : absolute;
        margin-top: 20px;
        margin-left: 30%;
        
    }
    .bg {
        width: 100%;
        height: 100%;
        position: fixed;
        /* background: url("~@/assets/loginImage.png"); */
        background-size: 100% 100%;
    }
    .button-row {
        display: flex;
        justify-content: right;
        border-top: solid 1px;
        
    }
    .button-row >.el-button {
        margin-top: 10px;
    }
</style>
